module.exports = __webpack_public_path__ + "img/logo1.a682c736.png";